"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const FavIcon = props => {
    return (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "0 0 90 90" }),
        react_1.default.createElement("path", { d: "M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5ZM66.24,75L50,62.34,33.76,75l6-18.76L23.72,44.13l20.75-.3L50,25l6.08,18.51,20.2,0.58L59.67,55.43Z", transform: "translate(-5 -5.03)" })));
};
exports.FavIcon = FavIcon;
exports.default = exports.FavIcon;
